module.exports = __webpack_public_path__ + "img/RIGID PGG KNUCKLE CRANE TRUCK_LHD.c14b4d04.jpg";